import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { useHost } from "@/context/HostContext";

/* Company Profile mode. Sumber: GET /api/public/company-profile
   (flag paket/override × switch tenant, di-resolve backend). Default & fail-safe "store".
   Phase 2: `sections` = hanya section enabled + berisi (proyeksi backend), `sectionOrder` tervalidasi. */
const EMPTY = { mode: "store", loading: false, hero: null, sections: {}, sectionOrder: [], catalogPath: "/katalog" };
const Ctx = createContext(EMPTY);

export function CompanyProfileProvider({ children }) {
  const host = useHost();
  const isTenant = host?.kind === "tenant";
  const [state, setState] = useState({ ...EMPTY, loading: isTenant });

  useEffect(() => {
    if (!isTenant) return undefined;
    let alive = true;
    api.get("/public/company-profile")
      .then(({ data }) => alive && setState({
        mode: data?.mode === "company_profile" ? "company_profile" : "store",
        loading: false,
        hero: data?.hero || null,
        sections: data?.sections && typeof data.sections === "object" ? data.sections : {},
        sectionOrder: Array.isArray(data?.section_order) ? data.section_order : [],
        catalogPath: data?.catalog_path || "/katalog",
      }))
      .catch(() => alive && setState((s) => ({ ...s, mode: "store", loading: false }))); // fail-safe → Store Only
    return () => { alive = false; };
  }, [isTenant]);

  return <Ctx.Provider value={state}>{children}</Ctx.Provider>;
}

export const useCompanyProfile = () => useContext(Ctx);
